
import { VacancyGetters, IVacancy } from '@tokyojob/core'
import { CButton, CVacancyImage } from '@tokyojob/frontend-components'
import Vue, { PropType } from 'vue'

export default Vue.extend({
  components: { CVacancyImage, CButton },
  props: {
    /**
     * Vacancy object used to populate details of this card
     */
    vacancyMap: {
      type: Object as PropType<IVacancy>,
      required: true,
    },
    /**
     * When not selected by parent, use this css style
     */
  },
  computed: {
    image(): string {
      return VacancyGetters.getThumbnailUrl(this.vacancyMap)
    },
    title(): string {
      return VacancyGetters.getTitle(this.vacancyMap)
    },
  }
})
